import { ACCENT, ACCENT_LIGHT } from './constants';
import { ProfessionIcon } from './profession-icon';

export const IconMore = () => (
  <ProfessionIcon bg={ACCENT_LIGHT}>
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
      <circle cx="6" cy="12" r="2" fill={ACCENT} />
      <circle cx="12" cy="12" r="2" fill={ACCENT} />
      <circle cx="18" cy="12" r="2" fill={ACCENT} />
    </svg>
  </ProfessionIcon>
);
